class UGCVideos extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll("video");
    this.wrapper = this.querySelector(".ugc-videos-wrapper");

    /*this.init();

    // Eventos para el mouse y touch
    this.wrapper.addEventListener("mousedown", (e) => this.handleOnDown(e));
    this.wrapper.addEventListener("touchstart", (e) => this.handleOnDown(e.touches[0]));
    this.wrapper.addEventListener("mouseup", () => this.handleOnUp());
    this.wrapper.addEventListener("touchend", () => this.handleOnUp());
    this.wrapper.addEventListener("mousemove", (e) => this.handleScroll(e));
    this.wrapper.addEventListener("touchmove", (e) => this.handleScroll(e.touches[0]));*/
  }

  openGallery(e) {
    console.log(e);
  }
  init() {
    this.wrapper.dataset.mouseDownAt = "0";
    this.wrapper.dataset.prevPercentage = "0";

    // Centrar inicialmente el video del medio
    const initialPercentage = 0;
    this.wrapper.style.transform = `translateX(${initialPercentage}%)`;
    this.wrapper.dataset.prevPercentage = initialPercentage;

    this.updateActiveVideo(initialPercentage);
  }

  handleScroll(e) {
    if (this.wrapper.dataset.mouseDownAt === "0") return;

    const mouseDelta = parseFloat(this.wrapper.dataset.mouseDownAt) - e.clientX;
    const maxDelta = this.innerWidth;

    const percentage = (mouseDelta / maxDelta) * -100;
    const nextPercentageUnconstrained = parseFloat(this.wrapper.dataset.prevPercentage) + percentage;

    // Limitar el movimiento entre el primer y último video
    const nextPercentage = Math.max(Math.min(nextPercentageUnconstrained, 0), -((this.videos.length - 1) * 100) / this.videos.length);

    this.wrapper.dataset.percentage = nextPercentage;

    // Mover el slider
    this.wrapper.style.transform = `translateX(${nextPercentage}%)`;

    // Actualizar el video activo
    this.updateActiveVideo(nextPercentage);
  }

  handleOnDown(e) {
    this.wrapper.dataset.mouseDownAt = e.clientX;
  }

  handleOnUp() {
    this.wrapper.dataset.mouseDownAt = "0";
    this.wrapper.dataset.prevPercentage = this.wrapper.dataset.percentage;
  }

  updateActiveVideo(percentage) {
    // Calcular el índice del video activo basado en el porcentaje
    const index = Math.round((Math.abs(percentage) / 100) * this.videos.length);

    this.videos.forEach((video, i) => {
      video.classList.remove("active");
      video.autoplay = false;

      if (i === index) {
        video.classList.add("active");
        video.autoplay = true;
      }
    });
  }
}

customElements.define("ugc-videos", UGCVideos);
